<script setup>
import { Link } from "@inertiajs/inertia-vue3";

const props = defineProps(["tabletteMode", "scroll"]);

</script>

<template>
  <div class="transform duration-200">
    <Link
      :href="!props.tabletteMode ? '/' : '#'"
      as="button"
      class="flex flex-col items-center justify-around p-2 text-lg rounded-lg w-36"
    >
      <img
        alt="OptiPlan"
        :class="['transform duration-100', props.scroll ? 'h-6':'h-8']"
        src="/images/logos/logo_or.png"
      />
      <span v-if="props.tabletteMode" class="ml-2 uppercase">tablette</span>
      <span v-else :class="[props.scroll ? 'text-xs':'text-base', 'uppercase font-sulphurPoint transform duration-100']">Optiplan</span>
    </Link>
  </div>
</template>
